export const CountryBrandSiteConstants = {
    GET_BRAND_COUNTRY: 'GET_BRAND_COUNTRY',
    SET_BRAND_COUNTRY: 'SET_BRAND_COUNTRY'
};